import { classNamePrefix } from '../globals';

export function renderModal (titleId: string, descriptionId: string) {
    const className = classNamePrefix + '-modal';

    const modalElement = document.createElement('div');
    modalElement.classList.add(className);
    modalElement.role = 'dialog';
    modalElement.ariaModal = 'false';
    modalElement.ariaLive = 'polite';
    modalElement.setAttribute('aria-labelledby', titleId);
    modalElement.setAttribute('aria-describedby', descriptionId);

    return modalElement;
}